var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Delete redirect ")]
          ),
          _vm.redirect
            ? _c("v-card-text", [
                _vm._v(" Are you certain that you wish to "),
                _c("b", [_vm._v("permanently")]),
                _vm._v(
                  " remove the redirect “" +
                    _vm._s(_vm.redirect.source) +
                    "” on “" +
                    _vm._s(_vm.redirect.domain) +
                    "”? "
                )
              ])
            : _vm._e(),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-end"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v(" Close ")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.deleteRedirect
                  }
                },
                [_vm._v(" Remove Redirect ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }